var _rect, _rect2, _path, _circle, _path2, _path3, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeycryptShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    fill: "#111827"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 105,
    width: 660,
    height: 300,
    rx: 24,
    fill: "#1f2937",
    stroke: "#38bdf8",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 150 530 195v82c0 70-53 108-130 131-77-23-130-61-130-131v-82z",
    fill: "#0e7490",
    stroke: "#a5f3fc",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 265,
    r: 44,
    fill: "#fbbf24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M400 238v54M373 265h54",
    stroke: "#451a03",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120 155h90M590 155h90M120 355h90M590 355h90",
    stroke: "#64748b",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 75,
    fill: "#e0f2fe",
    fontFamily: "sans-serif",
    fontSize: 42,
    fontWeight: 700
  }, "KEYCRYPT SHIELD")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 475,
    fill: "#7dd3fc",
    fontFamily: "monospace",
    fontSize: 22
  }, "SECURE ENCRYPTION &amp; KEY MANAGEMENT")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeycryptShield);
export default __webpack_public_path__ + "static/media/keycrypt-shield.92920b00b1282263e992ed3b815adaf8.svg";
export { ForwardRef as ReactComponent };